import React from 'react';
import Icon from '@ant-design/icons';

const MapSvg = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M16.307 3.038a1.5 1.5 0 00-1.114 0L8.807 5.593a1.5 1.5 0 01-1.114 0L1.779 3.227a.75.75 0 00-1.029.7V18.3a1.5 1.5 0 00.943 1.393l6 2.4a1.5 1.5 0 001.114 0l6.386-2.555a1.5 1.5 0 011.114 0l5.914 2.362a.75.75 0 001.029-.7V6.83a1.5 1.5 0 00-.943-1.392l-6-2.4z"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 5.7v16.5M15.75 2.93v16.5"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MapIcon = (props: any) => <Icon component={MapSvg} {...props} />;

export default MapIcon;
